import { type ChangeEvent, type FocusEvent } from 'react'

import { Icon, Input, PageWrapper } from '@/shared'
import { EIcons } from '@App/types/iconType'
import { type IChildServiceDec } from '@App/types/servicesTypes'

import style from './SearchService.module.scss'

interface IProps {
    onSearch: (e: ChangeEvent<HTMLInputElement>) => void
    onSearchByFocus: (e: FocusEvent<HTMLInputElement>) => void
    placeholder?: string
    searchState: IChildServiceDec[]
    setSearchState: (searchState: IChildServiceDec[]) => void
    onSetTranferSevice: (tranferSevice: IChildServiceDec | null) => void
    // onClear?: () => void // TODO: Приделать удаление строки
}

export const SearchService = (props: IProps) => {
    const { onSearch, placeholder, searchState, setSearchState, onSearchByFocus, onSetTranferSevice } = props

    return (
        <PageWrapper>
            <div className={style.container}>
                <Input
                    className={style.searchField}
                    onBlur={() => setSearchState([])}
                    onFocus={onSearchByFocus}
                    onChange={onSearch}
                    placeholder={placeholder}
                />
                <div className={style.search}>
                    <Icon iconName={EIcons.SRCH} color='#777e90' />
                </div>
                {searchState.length > 0 && (
                    <div className={style.options}>
                        {searchState.slice(0, 10).map((opt) => {
                            const { id, name } = opt
                            return (
                                <div key={id} className={style.option} onMouseDown={() => onSetTranferSevice(opt)}>
                                    <span>{name}</span>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </PageWrapper>
    )
}
